import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import Label from 'components/_utility/Label';
import ChevronRight from 'src/assets/icons/chevron-right.svg';

import { getConfigurations } from 'src/redux/garage/selectors';
import { setConfigurations } from 'src/redux/garage/actions';
import request from 'helpers/request';
import { Wrap, Message, CTA } from './NotificationStrip.styled';

const NotificationStrip = () => (
  <Wrap>
    <Message>
      <Label name="previouslySavedBikesLabel" />
      <CTA to="/garage">
        <Label name="myGarageLabel" /> <ChevronRight />
      </CTA>
    </Message>
  </Wrap>
);

export const NotificationStripPortal = () => {
  const dispatch = useDispatch();
  const userEmail = window.localStorage.getItem('garageEmailAddress');
  const configurations = useSelector(getConfigurations);
  let notificationStripEl = document.querySelector('.notification-strip');
  const breadcrumbEl = document.querySelector('.breadcrumb');

  if (!notificationStripEl && breadcrumbEl?.parentNode) {
    notificationStripEl = document.createElement('div');
    breadcrumbEl.parentNode.insertBefore(notificationStripEl, breadcrumbEl);
  }

  useEffect(() => {
    if (!userEmail) {
      return;
    }

    const fetchConfigurations = async () => {
      const { data } = await request(`/api/configurator/garage?user=${userEmail}`);

      dispatch(setConfigurations(data ? data.configurations : []));
    };

    fetchConfigurations();
  }, [dispatch, userEmail]);

  return (userEmail && configurations.length && createPortal(<NotificationStrip />, notificationStripEl)) || null;
};

export default NotificationStrip;
